import CmsModules from "theme/libs/wordpress/content/CmsModules";
import ContentWrapper from "theme/components/wrappers/ContentWrapper";
import MembershipOverview from "theme/components/myAccount/MembershipOverview";
import Promotions from "theme/components/myAccount/Promotions";
import PropTypes from "prop-types";
import React from "react";
import styled from "theme/libs/styled";

const Wrapper = styled(ContentWrapper)`
    display: grid;
    grid-template-columns: 1fr;
    margin-top: 16px;

    ${({ theme }) => theme.above.desktopSm} {
        grid-row-start: 2;
        grid-column-start: 2;
        grid-column-end: 4;
        margin-top: 0px;
    }
`;

const Default = ({ page_content: pageContent, overview, promotions }) => {
    const isOverviewActivated = overview?.activation?.display === "enable";
    const isPromotionsActivated = promotions?.activation?.display === "enable" && !!promotions?.show_more_link.length;

    return (
        <Wrapper>
            {isOverviewActivated && <MembershipOverview showReadMore />}
            {isPromotionsActivated && (
                <Promotions showMoreButton moreButtonLink={promotions.show_more_link} maxCount={3} />
            )}
            <CmsModules isWithoutBleedWrapper data={pageContent} />
        </Wrapper>
    );
};

Default.propTypes = {
    page_content: PropTypes.array.isRequired,
};

export default Default;
